import { computed } from '@nuxtjs/composition-api';
import { sharedRef, useVSFContext } from '@vue-storefront/core';
// import {
//   CustomQuery
// } from '@vue-storefront/core';
import { useApiError } from '../useApiError';

export const useConfig = (orderId: string): any => {
  const { set: setError } = useApiError();
  // Loads context used to call API endpoint
  const context = useVSFContext();
  // console.log("useConfigcontext---------", context.useApiError);
  // Shared ref holding the response from the API
  const configResult = sharedRef(null, `useConfig-${orderId}`);
  // Shared ref indicating whether any method is waiting for the data from the API
  const loading = sharedRef(false, `useConfig-loading-${orderId}`);

  // Shared ref holding errors from the methods
  const error = sharedRef({}, `useConfig-error-${orderId}`);

  // Method to call an API endpoint and update `result`, `loading` and `error` properties
  const configGet = async (customQuery) => {
    try {
      loading.value = true;
      const res = await context.$xbuy.api.configList(customQuery);
      // context.useApiError.set(res);
      if (res && res.code === 0) {
        if (res.data?.list?.config) {
          res.data.list.config = JSON.parse(res.data?.list?.config);
        }
        configResult.value = res.data?.list;
        error.value = null;
      } else {
        setError(res);
        error.value = new Error(res.message);
      }
    } catch (err) {
      error.value = err;
    } finally {
      loading.value = false;
    }
  };
  return {
    configList: configGet,
    configs: computed(() => configResult.value),
    loading: computed(() => loading.value),
    error: computed(() => error.value)
  };
};
